module.exports = __webpack_public_path__ + "media/b3.b20d86f4.mp3";